export default __webpack_public_path__ + "static/media/cdf.b527c1e8.svg";